export const OAuthSettings = {
    appId: 'b90f7504-2805-4394-8707-9cb2211a204c',
    scopes: [
        "group.read.all",
        "tasks.readwrite.shared",
        "user.read",
        "user.readbasic.all"
    ]
}